import Spinner from './Spinner';

export { Spinner as default };
